<rt-dialog-header
  [heading]="
    (isEditing ? 'wysiwyg.video_plugin.edit_video' : 'wysiwyg.video_plugin.add_video') | translate
  "
></rt-dialog-header>

<rt-dialog-body layout-horizontal>
  <rt-form-field>
    <rt-label>{{ 'wysiwyg.video_plugin.yt_vimeo_link' | translate }}</rt-label>
    <rt-input [autoFocus]="true" [rtFormError]="errors" [formControl]="formControl"></rt-input>
  </rt-form-field>
</rt-dialog-body>

<rt-dialog-footer [hasOptionalActions]="true">
  @if (isEditing) {
    <rt-button (click)="delete()" class="optional danger-on-hover" variant="plain">
      <rt-icon prefix name="delete"></rt-icon>{{ 'wysiwyg.delete' | translate }}
    </rt-button>
  }
  <rt-button (click)="cancel()" variant="outline">{{ 'wysiwyg.cancel' | translate }}</rt-button>
  <rt-button [disabled]="formControl.invalid" (click)="changeSource()" variant="primary">{{
    isEditing ? 'Replace' : 'Insert'
  }}</rt-button>
</rt-dialog-footer>
